export enum ReadingType {
    POWER = "power",
    POWER_LOAD = "power-load",
    POWER_SUPPLY = "power-supply",
    COOLING = "cooling",
    COOLING_LOAD = "cooling-load",
    COOLING_SUPPLY = "cooling-supply",
}